import React from 'react'
import Filter from '../../../Components/DMM/Assistant/Filter'

const index = () => {
  return <Filter />
}

export default index